import { SupportSuccessModal } from '@/features/support';
import { SupportIcon } from '@/lib';
import { ComponentProps, FC, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { BASE_SIDEBAR_ITEM_STYLES, BaseSidebarItem } from '../BaseSidebarItem';
import { SupportModal, SupportModalType } from './SupportModal';

type SidebarSupportItemProps = Pick<ComponentProps<typeof BaseSidebarItem>, 'classNames'> & {
  classNames?: {
    item?: string;
  };
};

export const SidebarSupportItem: FC<SidebarSupportItemProps> = ({ classNames }) => {
  const [showedModal, setShowedModal] = useState<SupportModalType | null>(null);

  const closeModal = () => setShowedModal(null);
  const showSupportModal = () => setShowedModal('default');
  const showConfirmModal = () => setShowedModal('confirmation');

  const isSupportModalVisible = showedModal === 'default';
  const isConfirmationModalVisible = showedModal === 'confirmation';

  return (
    <>
      <li>
        <button onClick={showSupportModal} className={twMerge('w-full', BASE_SIDEBAR_ITEM_STYLES, classNames?.item)}>
          <BaseSidebarItem icon={SupportIcon} title={'support'} classNames={classNames} />
        </button>
      </li>
      {isSupportModalVisible && <SupportModal onConfirm={showConfirmModal} onClose={closeModal} />}
      {isConfirmationModalVisible && <SupportSuccessModal onConfirm={async () => closeModal()} onClose={closeModal} />}
    </>
  );
};
